module.exports = "<div class=\"js-popout-region\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/dateTime/templates/date.hbs
// module id = 656
// module chunks = 0